import React, { ReactNode, useEffect, useState } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { Theme } from '@mui/material';
import { themeCreator } from './base';
import { currentUser } from 'system/InfegyUser';
// import { CacheProvider } from '@emotion/react';
// import createCache from '@emotion/cache';
// import stylisRTLPlugin from 'stylis-plugin-rtl';

// const cacheRtl = createCache({
//   key: 'bloom-ui',
// prepend: true,
//   // @ts-ignore
//   stylisPlugins: [stylisRTLPlugin]
// });

export const ThemeContext = React.createContext(
  (themeName: string): void => {}
);

type Props = {
  children: ReactNode
}

export default function ThemeProviderWrapper(props: Props): React.JSX.Element {
  const themeNameDefault = "PureLightTheme";
  const [themeName, _setThemeName] = useState(themeNameDefault);
  const [theme, setTheme] = useState<Theme>(themeCreator(themeName));

  function setThemeName(value: string): void {
    _setThemeName(value);
  }

  useEffect(() => {
    const newThemeName = currentUser()?.preferences.theme ?? themeNameDefault;
    _setThemeName(newThemeName);
  }, [currentUser()?.preferences.theme]);

  useEffect(() => {
    const newTheme = themeCreator(themeName);
    setTheme(newTheme);
  }, [themeName]);

  return (
    <StyledEngineProvider injectFirst>
      {/* <CacheProvider value={cacheRtl}> */}
      <ThemeContext.Provider value={setThemeName}>
        <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
      </ThemeContext.Provider>
      {/* </CacheProvider> */}
    </StyledEngineProvider>
  );
}
